import { TYPES } from 'action-types/nickname';
interface IAction {
    readonly type: string;
    readonly userNickName: any;
    readonly token: any;
}

export interface INickNameState {
    readonly token?: any | null;
    readonly userNickName: {
        'employeeId': string,
        'givenName': string,
        'id': string,
        'mailNickname': string
    }
}
export interface INickname{
    'employeeId': string,
    'givenName': string,
    'id': string,
    'mailNickname': string
}

export const defaultState: INickNameState = {
    userNickName: {
        'employeeId': '',
        'givenName': '',
        'id': '',
        'mailNickname': ''
    }

};

export const reducer = (state: INickNameState  = defaultState, action: IAction): INickNameState => {
    switch (action.type) {
        case TYPES.SET_NICKNAME:
            return {
                ...state,
                token: action.token
            };
        case TYPES.GET_USER_NICKNAME.PENDING:
            return {
                ...state,
            };
        case TYPES.GET_USER_NICKNAME.FULFILLED:
            const userDeatial = {...action.userNickName, employeeId: 'AUTUSR'};
            return {
                ...state,
            userNickName: action.userNickName.employeeId === null && process.env.NODE_ENV === 'test' ?  userDeatial : action.userNickName
            };
        case TYPES.GET_USER_NICKNAME.REJECTED:
            return {
                ...state,
            };
        default:
            return {
                ...state,
            };
    }
};
